var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFabExplain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 28,
    cy: 28,
    r: 28
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "201.8%",
    height: "201.8%",
    x: "-50.9%",
    y: "-31.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 7,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 7)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#79A611",
    d: "M42 48a1.998 1.998 0 0 1-1.412-.584A2.04 2.04 0 0 1 40 46c0-.528.212-1.044.588-1.416A2.037 2.037 0 0 1 42 44c.524 0 1.044.212 1.408.584.376.376.592.892.592 1.416 0 .524-.212 1.04-.592 1.416A2.013 2.013 0 0 1 42 48zM40.6 40.571v-5.714c0-.788.627-1.428 1.4-1.428 2.316 0 4.2-1.923 4.2-4.286 0-2.363-1.884-4.286-4.2-4.286-2.316 0-4.2 1.923-4.2 4.286 0 .788-.627 1.428-1.4 1.428-.773 0-1.4-.64-1.4-1.428C35 25.206 38.142 22 42 22s7 3.206 7 7.143c0 3.448-2.408 6.334-5.6 7v4.428C43.4 41.36 42.773 42 42 42c-.773 0-1.4-.64-1.4-1.429z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFabExplain);
export default __webpack_public_path__ + "static/media/fab-explain.7614a21411567ffb298fada1e32cbf4f.svg";
export { ForwardRef as ReactComponent };